/* eslint-disable import/no-anonymous-default-export */
import * as Types from "./navmode.type";

interface INavMode {
  mode: string;
  school: null | object;
  route: null | object;
  address_changes: null | object;
  is_finish_fetch_optimisation_route: boolean;
}

const initialState: INavMode = {
  mode: null,
  school: null,
  route: null,
  address_changes: null,
  is_finish_fetch_optimisation_route: false,
};

export default (state = initialState, action: any) => {
  switch (action.type) {
    case Types.CHANGE_ACTIVE_NAV:
      const { mode } = action.payload;
      return {
        ...state,
        mode,
      };
    case Types.CHANGE_ACTIVE_SCHOOL:
      const { school } = action.payload;
      return {
        ...state,
        school,
      };
    case Types.REHYDRATE_NAV_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case Types.CHANGE_SELECTED_ROUTE:
      const { route } = action.payload;
      return {
        ...state,
        route,
      };
    case Types.CHANGE_SELECTED_ADDRESS_FROM_MARKER:
      const { address_changes } = action.payload;
      return {
        ...state,
        address_changes,
      };
    case Types.UPDATE_ROUTE_TIME_DATA:
      const { route_time_data } = action.payload;
      return {
        ...state,
        route_time_data,
      };
    case Types.IS_FINISH_FETCH_OPTIMISATION_ROUTE:
      const { is_finish_fetch_optimisation_route } = action.payload;
      return {
        ...state,
        is_finish_fetch_optimisation_route,
      };
    default:
      return state;
  }
};
